"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkOverlay = exports.DarkOverlayStyle = exports.LightOverlay = exports.LightOverlayStyle = void 0;

var polished_1 = require("polished");

var styledTypes_1 = require("./styledTypes");

function LightOverlayStyle(theme) {
  return {
    backdropFilter: 'blur(3px) saturate(70%)',
    background: (0, polished_1.transparentize)(0.5, theme['@gray-2'])
  };
}

exports.LightOverlayStyle = LightOverlayStyle;
exports.LightOverlay = styledTypes_1.styled.div(function (props) {
  return LightOverlayStyle(props.theme);
});

function DarkOverlayStyle(theme) {
  return {
    backdropFilter: 'blur(3px)',
    background: (0, polished_1.transparentize)(0.5, theme['@gray-7'])
  };
}

exports.DarkOverlayStyle = DarkOverlayStyle;
exports.DarkOverlay = styledTypes_1.styled.div(function (props) {
  return DarkOverlayStyle(props.theme);
});